<template>
  <div class="screen">
    <img
      class="screen-bg bg-top screen-bg-1"
      src="../../assets/roomscreen/bg_1.png"
    />
    <img
      class="screen-bg bg-bottom screen-bg-2"
      src="../../assets/roomscreen/bg_2.png"
    />
    <img
      class="screen-bg bg-bottom screen-bg-3"
      src="../../assets/roomscreen/bg_3.png"
    />

    <img
      class="screen-logo logo-1"
      src="../../assets/roomscreen/screen_logo_1.png"
    />
    <img
      class="screen-logo logo-2"
      src="../../assets/roomscreen/screen_logo_2.png"
    />

    <img class="screen-qrcode" src="../../assets/roomscreen/qrcode_3.png" />
    <div class="screeb-qrcode-tips">
      <i
        v-for="i of 6"
        :key="i"
        class="el-icon-arrow-right"
        style="width: 2.5vw; font-weight: bold"
      />&nbsp;&nbsp;&nbsp;活动详询
    </div>

    <div class="screen-content-container">
      <div class="screen-header-title">{{ screen.title }}</div>
      <div class="screen-content-header">
        <el-carousel
          @touchstart="CarouselTouchStart"
          @touchend="CarouselTouchEnd"
          class="screen-content-header-coverimg"
          direction="horizontal"
          v-if="screen.coverImage"
          :interval="5000"
          arrow="always"
        >
          <el-carousel-item
            :style="{
              backgroundImage: 'url(' + screen.coverImage.url + ')',
              backgroundSize: '100% 100%',
              backgroundRepeat: 'no-repeat',
            }"
          >
          </el-carousel-item>
          <el-carousel-item
            v-for="(img, index) of screen.contentImage"
            :key="index"
            :style="{
              backgroundImage: 'url(' + img.url + ')',
              backgroundSize: '100% 100%',
              backgroundRepeat: 'no-repeat',
            }"
          >
          </el-carousel-item>
        </el-carousel>
        <div style="overflow: hidden; width: 70%; margin: 0 auto">
          <div class="screen-content-header-desc">
            <div class="roller">{{ screen.description }}</div>
          </div>
        </div>
      </div>
      <div class="screen-content-body">
        <div class="screen-content-body-title">活动排片</div>
        <div class="screen-content-linker linker-1"></div>
        <div class="screen-content-linker linker-2"></div>
        <div class="screen-content-linker linker-3"></div>
        <div class="screen-content-linker linker-4"></div>
        <div class="screen-content-table">
          <el-table
            style="width: 100%"
            height="90%"
            empty-text="暂无活动"
            :show-header="false"
            :data="showTable"
            :cell-style="cellStyle"
          >
            <el-table-column
              v-for="index of screen.roomScreenConfig.columns"
              :min-width="showTableWidth[index - 1]"
              :key="index"
              :prop="'col' + (index - 1)"
            >
              <template slot-scope="scope">
                <div class="cell">
                  <div class="cell-wrap">
                    <div class="roller">
                      {{ scope.row["col" + (index - 1)] }}
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getRoomScreenDetail } from "../../api/api";
export default {
  data() {
    return {
      cellStyle: {
        padding: "0",
        height: "5vw",
        lineHeight: "5vw",
        background: "#fbdcdc",
        fontSize: "2.5vw",
        fontWeight: "bold",
        color: "#e86480",
      },
      screen: {
        id: 0,
        roomScreenConfig: {
          columns: 0,
          rows: 0,
          extensionData: "[]",
        },
      },
      showTable: [],
      showTableWidth: [],
      isLoading: false,
      timeInterval: null,
      carouselTouchStartX: 0,
      carouselTouchStartY: 0,
    };
  },
  methods: {
    CarouselTouchStart(e) {
      this.carouselTouchStartX = e.touches[0].clientX;
      this.carouselTouchStartY = e.touches[0].clientY;
    },
    CarouselTouchEnd(e) {
      let deltaX = e.changedTouches[0].clientX - this.carouselTouchStartX;
      let deltaY = e.changedTouches[0].clientY - this.carouselTouchStartY;
      if (
        Math.abs(deltaX) > this.delta &&
        Math.abs(deltaX) > Math.abs(deltaY)
      ) {
        if (deltaX >= 0) {
            this.$notify({ message: "右滑", type: "info" });
        } else {
            this.$notify({ message: "左滑", type: "info" });
        }
      }
    },
    GetRoomScreenDetail() {
      let param = { id: this.screen.id, i: Math.random() };
      this.isLoading = true;
      getRoomScreenDetail(param).then((res) => {
        this.isLoading = false;
        if (res.data.isSuccess) {
          this.screen = res.data.response;
          if (
            this.screen.roomScreenConfig &&
            this.screen.roomScreenConfig.extensionData
          ) {
            let extensionData = JSON.parse(
              this.screen.roomScreenConfig.extensionData
            );
            this.showTable = extensionData.dataConfigs || [];
            this.showTableWidth = extensionData.columnWidthConfigs || [];
          }
        }
      });
    },
  },
  destroyed() {
      if(this.timeInterval){
        clearInterval(this.timeInterval);
      }
  },
  mounted() {
    let _this = this;
    _this.screen.id = _this.$route.query.id;
    _this.GetRoomScreenDetail();
    if(_this.timeInterval){
        clearInterval(_this.timeInterval);
    }
    _this.timeInterval = setInterval(() => {
        if(!_this.isLoading){
            _this.GetRoomScreenDetail();
        }
    }, 20000);
  },
};
</script>

<style scoped>
.screen {
  height: 100vh;
  width: 100vw;
  background-color: #e84848;
  font-family: "华康POP2体W9(P)" !important;
  font-weight: normal !important;
}
.screen-bg {
  width: 100vw;
  opacity: 0.9;
}
.bg-top {
  position: fixed;
  top: 0;
  left: 0;
}
.bg-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
}
.screen-logo {
  width: 10vw;
}
.logo-1 {
  position: fixed;
  top: 4vh;
  left: 6vw;
}
.logo-2 {
  position: fixed;
  top: 4vh;
  left: 20vw;
}
.screen-qrcode {
  position: fixed;
  bottom: 4vh;
  right: 6vw;
  width: 22vw;
}
.screeb-qrcode-tips {
  font-size: 6vw;
  font-weight: bold;
  color: #fff;
  position: fixed;
  bottom: 4vh;
  left: 6vw;
  height: 22vw;
  line-height: 22vw;
  letter-spacing: 1vw;
  text-shadow: 3px 3px 0 #e84848;
}
.screen-content-container {
  position: fixed;
  width: 88vw;
  height: 68vh;
  left: 6vw;
  top: 13vh;
}
.screen-header-title {
  font-size: 10vw;
  color: #fff;
  width: 100%;
  height: 12%;
  line-height: 10vw;
  text-align: center;
  text-shadow: 3px 3px 0 #f488a0;
}
.screen-content-header {
  width: 100%;
  height: 42%;
  background-color: #fdeeee;
  border-radius: 2vw;
  text-align: center;
  padding: 3vw 0;
}
.screen-content-header .screen-content-header-coverimg {
  margin: auto;
  width: 70%;
  max-width: 70%;
  max-height: 80%;
}
.screen-content-header >>> .el-carousel__container {
  height: 22.848vh;
}
.screen-content-header >>> .el-carousel__container .el-carousel__arrow {
  font-size: 5vw;
  height: 5vw;
  line-height: 5vw;
  /* display: none; */
}
.screen-content-header .screen-content-header-desc {
  font-size: calc(2vh + 1px);
  font-weight: bold;
  color: #e75b79;
  height: 15%;
  width: 100%;
  margin: auto;
  line-height: 4.4vh;
  margin-top: 1vh;
  animation: roller-wrap 15s infinite linear;
}
.screen-content-header .screen-content-header-desc .roller {
  white-space: nowrap;
  min-width: 100%;
  animation: roller 15s infinite linear;
  float: left;
}
/* .screen-content-header .screen-content-header-desc .roller:hover{
    white-space: nowrap;
    min-width: 100%;
    animation: roller 15s infinite linear paused;
    float: left;
} */
@keyframes roller {
  0%,
  30% {
    transform: translateX(0);
  }
  70%,
  100% {
    transform: translateX(-100%);
  }
}
@keyframes roller-wrap {
  0%,
  30% {
    transform: translateX(0);
  }
  70%,
  100% {
    transform: translateX(100%);
  }
}
.screen-content-body {
  width: 100%;
  height: 38%;
  margin-top: 6%;
  background-color: #fdeeee;
  border-radius: 2vw;
  position: relative;
}
.screen-content-body .screen-content-linker {
  position: absolute;
  top: -4vh;
  width: 1.5vw;
  height: 4.5vh;
  border: solid 3px #e84848;
  background-color: #fdeeee;
  border-radius: 15px;
  rotate: 90;
}
.screen-content-body .screen-content-body-title {
  position: absolute;
  top: -2vh;
  left: 30%;
  width: 40%;
  height: 7vw;
  line-height: 7vw;
  background-color: #f06d6d;
  background-image: linear-gradient(30deg, #f24d4d, #f06d6d);
  color: #fff;
  font-size: 5vw;
  border-radius: 20px;
  text-align: center;
}
.screen-content-body .screen-content-table {
  position: absolute;
  left: 5%;
  top: 15%;
  width: 90%;
  height: 80%;
}
.screen-content-body .screen-content-table >>> .el-table {
  background-color: transparent;
}
.screen-content-body .screen-content-table >>> table {
  -webkit-border-horizontal-spacing: 0.6vw;
  -webkit-border-vertical-spacing: 0.6vw;
}
.screen-content-body
  .screen-content-table
  >>> .el-table--scrollable-x
  .el-table__body-wrapper {
  overflow: hidden;
}
.screen-content-body .screen-content-table .cell {
  overflow: hidden;
  width: 100%;
  margin: 0 auto;
}
.screen-content-body .screen-content-table .cell-wrap {
  width: 100%;
  margin: 0 auto;
  animation: roller-wrap 15s infinite linear;
}
.screen-content-body .screen-content-table .roller {
  white-space: nowrap;
  min-width: 100%;
  animation: roller 15s infinite linear;
  float: left;
}
/* .screen-content-body .screen-content-table .roller:hover{
    white-space: nowrap;
    min-width: 100%;
    animation: roller 15s infinite linear paused;
    float: left;
} */
.linker-1 {
  left: 10%;
}
.linker-2 {
  left: 20%;
}
.linker-3 {
  left: 80%;
}
.linker-4 {
  left: 90%;
}
</style>